// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"516":"28ef49c500d2bc5ab967","532":"b5fd9c32a2bc6f98d646","870":"d5b92db950fd05774773","956":"f82de7735fa80e5b8373"}[chunkId] + ".chunk.js";
};